import { api } from "../api";

/**
 * identifierFindAllExportResponse - Function that finds on database all drivers identifiers by status and then exports in a PDF/XSLX file  
 * /identifiers/{status}/${type}/export   
 * method GET  
 * @async-function
 */
const identifierFindAllExportResponse = async (token: string, managerId: number, status: string, type: string, simpleXlsxExport = false) => {
    const response = await api.get(
        `/identifiers/${managerId}/${status}/${type}/export?simpleXlsxExport=${simpleXlsxExport}`, {
            responseType: "arraybuffer",
            headers: {
                'Authorization': `Bearer ${token}`
            },
           
        }
    );
    return response;
};
export default identifierFindAllExportResponse;